module.exports = "https://static.wmbcdn.com/uniweb/images/839f919e885a251b32d2ee44fee04d1c.svg";